import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import loginBg from "../../content/bg.png";
import "./LoginPage.css";

export default function LoginPage() {
  const { instance } = useMsal();

  function handleLogin() {
    instance.loginRedirect(loginRequest).catch(console.error);
  }

  return (
    <div className="lp-page">
      <section className="lp-brand-panel" style={{ "--lp-bg-image": `url(${loginBg})` }} aria-label="BD Command Center" />

      <section className="lp-login-panel">
        <div className="lp-login-card">
          <img src="/DTC_logo.png" alt="DTC" className="lp-card-logo" />
          <h2 className="lp-card-title">ยินดีต้อนรับ</h2>
          <p className="lp-card-subtitle">เข้าสู่ระบบเพื่อใช้งาน BD Command Center</p>

          <button className="lp-login-btn" onClick={handleLogin}>
            <span className="lp-sso-icon" aria-hidden="true" />
            เข้าสู่ระบบด้วย Microsoft 365
          </button>

          <div className="lp-card-footer">
            <div>โปรแกรมสำหรับใช้งานภายใน (Internal Use Only)</div>
            <div>© 2026 D.T.C. Enterprise PCL. All rights reserved.</div>
          </div>
        </div>
      </section>
    </div>
  );
}
